import TaskView16 from '@carbon/icons-react/es/task--view/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';

const Wrapper = styled.div`
  display: inline-block;
  height: 100%;
`;

const StyledButton = styled(Button)`
  color: var(--gray-70);
  padding-left: var(--spacing-03);
  padding-right: var(--spacing-03);
  margin-right: var(--spacing-05);
  :hover {
    color: var(--blue-60);
  }
`;

interface Props {
  showDetail: () => void;
  className?: string;
}
export const ActionCell: FC<Props> = ({ showDetail, className }) => {
  const viewEnrtiesText = useTranslation('timesheets.view.entries.notes');

  return (
    <Wrapper className={className}>
      <Tooltip title={viewEnrtiesText} mouseEnterDelay={0.8}>
        <StyledButton type="link" onClick={showDetail}>
          <TaskView16 />
        </StyledButton>
      </Tooltip>
    </Wrapper>
  );
};
